import React from "react";
import { Route, Redirect } from "react-router-dom";
import { isTokenExpired, clearAuth } from "./login";

const PrivateRoute = ({ checkRole, component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        const token = localStorage.getItem("token");
        if (!token || isTokenExpired(token)) {
          clearAuth();
          return <Redirect to="/login" />;
        }
        if (!checkRole) {
          return <Redirect to="/error" />;
        }
        return <Component {...props} />;
      }}
    />
  );
};

export default PrivateRoute;
